import React from 'react'
import clsx from 'clsx'

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  disabled = false,
  loading = false,
  className,
  ...props
}) => {
  const base =
    'inline-flex items-center justify-center gap-2 font-medium rounded-lg transition focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-transparent disabled:opacity-50 disabled:cursor-not-allowed'

  const variants = {
    // Reveal — luminous gold on midnight ink
    primary:
      'bg-gradient-to-b from-gold-soft to-gold text-midnight-900 hover:brightness-105 focus:ring-gold/50 shadow-sm',
    outline:
      'border border-parchment-border bg-white/60 text-ink hover:bg-white focus:ring-gold/40 dark:border-midnight-600 dark:bg-midnight-700/40 dark:text-mist dark:hover:bg-midnight-700',
    ghost:
      'text-ink-soft hover:bg-parchment-200 focus:ring-gold/30 dark:text-mist/70 dark:hover:bg-midnight-700',
  }

  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-5 py-2.5 text-sm',
    lg: 'px-6 py-3 text-base',
  }

  return (
    <button
      className={clsx(base, variants[variant], sizes[size], className)}
      disabled={disabled || loading}
      {...props}
    >
      {loading && (
        <svg className="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      )}
      {children}
    </button>
  )
}

export default Button
